const placeholder = "https://cdn.scoutfeedback.com/gdot-workshop/placeholder.png"

export { placeholder }